var _excluded = ["className", "disabled", "error", "inputRef", "name", "required", "size", "valid", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useEffect } from 'react';
import classnames from 'classnames';
import { ChevronDown } from "../Icon";
import StyledSelect, { StyledSelectIcon, StyledSelectSelect } from "./styled";
import { useTheme } from 'styled-components';
import BackgroundProvider from "../BackgroundProvider";
var Select = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    inputRef = _ref.inputRef,
    name = _ref.name,
    required = _ref.required,
    size = _ref.size,
    valid = _ref.valid,
    width = _ref.width,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme() || {};
  useEffect(function () {
    if (size) {
      console.warn('The `size` prop in component `Select` is deprecated. Due to compatibility ' + 'issues on mobile devices we recommend that you use a standard dropdown input.');
    }
  }, [size]);
  var selectClassNames = classnames('csl-select__select', className, {
    'csl-select__select--valid': valid
  });
  return /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.color_input_background_default
    }
  }, /*#__PURE__*/React.createElement(StyledSelect, {
    $width: width,
    className: "csl-select",
    ref: ref
  }, /*#__PURE__*/React.createElement(StyledSelectSelect, _extends({}, rest, {
    $valid: valid,
    "aria-invalid": error,
    className: selectClassNames,
    disabled: disabled,
    id: name,
    name: name,
    ref: inputRef,
    required: required,
    size: size
  })), !size && /*#__PURE__*/React.createElement(StyledSelectIcon, {
    className: "csl-select__icon"
  }, /*#__PURE__*/React.createElement(ChevronDown, {
    iconSize: "md",
    size: "s2",
    trim: true
  }))));
});
Select.displayName = 'Select';
export default Select;